import { bl_ppl_to_xap_submission_queue_RowClass } from '../../../dbschema/bl_ppl_to_xap_submission_queue.model';
import { BaseContainerModel } from '../../base-container.model';

export class PeppolXAPSubmissionQueueContainerModel extends BaseContainerModel {
    bl_ppl_to_xap_submission_queue: bl_ppl_to_xap_submission_queue_RowClass = new bl_ppl_to_xap_submission_queue_RowClass();
}
